export default "__VITE_ASSET__660fff0f__"